/**
 * region for libraries*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

/**
 * region for components*/
import ListLabel from '../common/ListLabel';
import ListChip from '../common/ListChip';

//import ChipInput from 'material-ui-chip-input'

/**
 * region for hepers*/
import ajax from '../../helpers/ajax';
import Constants from '../../constants/Constants';

/**
 * region for styles*/
import { relationsKeywordStyle } from './style/relationsKeywordStyle';

class RelationsKeyword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sites: [],
            chanels: [],
            categories: []
        }
    }

    load() {
        let self = this;
        let requestData = {
            idkeyword: self.props.keyword.IDKEYWORD
        };
        let sites = [];
        let chanels = [];
        let categories = [];
        ajax.get(Constants.ROUTE_API_CONTENT_DETAILS_BY_KEYWORD,
            {
                requestData: requestData,
                success: function (response) {
                    sites = response.data[0].SITES;
                    chanels = response.data[0].CHANNELS;
                    categories = response.data[0].CATEGORIES;
                    self.setState({ sites: sites, chanels: chanels, categories: categories });
                }
            });
    }

    componentDidMount() {
        this.load();
    }

    render() {
        const { keyword} = this.props;
        let self = this;
        return (
            <div>
                <ListLabel
                    title="Sites:"
                    items={self.state.sites} />
                <ListLabel
                    title="Channels:"
                    items={self.state.chanels} />
                <ListChip
                    title="Categories:"
                    keyword={keyword}
                    items={self.state.categories} />

            </div>
        );
    }
}
RelationsKeyword.propTypes = {
    classes: PropTypes.object.isRequired
};
export default withStyles(relationsKeywordStyle)(RelationsKeyword);





